export const favoriteFilterKeys = {
  agentIds: 'favAgentASRAgentIds',
  agentRoles: 'favAgentASRAgentRoles',
  productIds: 'favAgentASRProductIds',
  platformIds: 'favAgentASRPlatformIds',
  managerIds: 'favAgentASRManagerIds',
  affiliateIds: 'favAgentSRAffiliateIds',
  trackerIds: 'favAgentASRTrackerIds',
  creativeIds: 'favAgentASRCreativeIds',
  brands: 'favAgentASRBrands',
  currencies: 'favAgentASRCurrencies',
  dealTypes: 'favAgentASRDealTypes',
  registrationDates: 'favAgentASRRegDates',
  firstDepositDates: 'favAgentASRFirstDepDates',
  anid: 'favAgentASRAnid',
  playerId: 'favAgentASRPlayerId',
  source1: 'favAgentASRSource1',
  source2: 'favAgentASRSource2',
  source3: 'favAgentASRSource3',
  source4: 'favAgentASRSource4',
  source5: 'favAgentASRSource5',
  deviceTypes: 'favAgentASRDeviceTypes',
  geo: 'favAgentASRGeo',
}

export const reportStorageProps = {
  type: 'ag-agent-statistics-report',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  savedReportTarget: 'ag-agent-statistics-report-settings',
  savedReportFavoritesTarget: 'ag-agent-statistics-report-favorites',
  savedReportDefaultTarget: 'ag-agent-statistics-report-default',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to', 'displayInPlayerCurrency'],
  exceptionsIds: ['productIds', 'platformIds', 'managerIds', 'affiliateIds', 'agentIds', 'agentRoles', 'trackerIds', 'brands', 'currencies', 'dealTypes', 'deviceTypes'],
  exceptionsStr: ['anid', 'source1', 'source2', 'source3', 'source4', 'source5'],
  maxFavoriteReports: 10,
}


